import React from "react";
import FemaleIcon from "../../../../../components/utils/icons/female";
import MaleIcon from "../../../../../components/utils/icons/male";
import { numberMask } from "../../../../../services/helpersMethodsService";
import {
  ActiveAnimalsContainer,
  AnimalInfoContainer,
  DataContainer,
  IconContainer,
  LabelCell,
  StockingRateContainer,
  TotalAnimalsLabel,
  TotalAnimalsNumber,
  ValueCell
} from "../styles";

const AnimalInfoDisplay = ({
  animalData,
  translation,
  showStockingRate = false,
}) => {
  if (!animalData) {
    return null;
  }

  const { stockingRate, totalAnimals, maleStatistics, femaleStatistics } = animalData;

  return (
    <AnimalInfoContainer>
      {showStockingRate && (
        <StockingRateContainer>
          <strong>{translation.areaMap.modal.production.stockingRate}: </strong>
          {numberMask(stockingRate || 0)} UA/ha
        </StockingRateContainer>
      )}

      <ActiveAnimalsContainer>
        <TotalAnimalsNumber>
          {totalAnimals?.male + totalAnimals?.female || 0}
        </TotalAnimalsNumber>
        <TotalAnimalsLabel>
          {translation.areaMap.modal.production.activeAnimals}
        </TotalAnimalsLabel>
      </ActiveAnimalsContainer>

      <DataContainer>
        <div className="col">
          <div className="cell">
            <br />
          </div>
          <div className="cell">
            <IconContainer>
              <MaleIcon />
              <strong>
                {totalAnimals?.male || 0}
              </strong>
            </IconContainer>
          </div>
          <div className="cell">
            <IconContainer>
              <FemaleIcon />
              <strong>
                {totalAnimals?.female || 0}
              </strong>
            </IconContainer>
          </div>
        </div>

        {/* Weight average */}
        <div className="col">
          <LabelCell>
            <label>
              {translation.areaMap.modal.production.averageWeight}
            </label>
          </LabelCell>
          <ValueCell>
            <span>
              <strong>{numberMask(maleStatistics?.weightReal || 0)}</strong>{" "}
              {translation.areaMap.modal.production.kg}
            </span>
          </ValueCell>
          <ValueCell>
            <span>
              <strong>{numberMask(femaleStatistics?.weightReal || 0)}</strong>{" "}
              {translation.areaMap.modal.production.kg}
            </span>
          </ValueCell>
        </div>

        {/* Weight Projected average */}
        <div className="col">
          <LabelCell>
            <label>
              {translation.areaMap.modal.production.averageWeightProjected}
            </label>
          </LabelCell>
          <ValueCell>
            <span>
              <strong>{numberMask(maleStatistics?.weightProjected || 0)}</strong>{" "}
              {translation.areaMap.modal.production.kg}
            </span>
          </ValueCell>
          <ValueCell>
            <span>
              <strong>{numberMask(femaleStatistics?.weightProjected || 0)}</strong>{" "}
              {translation.areaMap.modal.production.kg}
            </span>
          </ValueCell>
        </div>

        {/* GDP */}
        <div className="col">
          <LabelCell>
            <label>
              {translation.areaMap.modal.production.averageGdp}
            </label>
          </LabelCell>
          <ValueCell>
            <span>
              <strong>{numberMask(maleStatistics?.gdp || 0)}</strong>{" "}
              {translation.areaMap.modal.production.kg}
            </span>
          </ValueCell>
          <ValueCell>
            <span>
              <strong>{numberMask(femaleStatistics?.gdp || 0)}</strong>{" "}
              {translation.areaMap.modal.production.kg}
            </span>
          </ValueCell>
        </div>

        {/* Age average */}
        <div className="col">
          <LabelCell>
            <label>
              {translation.areaMap.modal.production.averageAge}
            </label>
          </LabelCell>
          <ValueCell>
            <span>
              <strong>{maleStatistics?.age || 0}</strong>{" "}
              {translation.areaMap.modal.production.months}
            </span>
          </ValueCell>
          <ValueCell>
            <span>
              <strong>{femaleStatistics?.age || 0}</strong>{" "}
              {translation.areaMap.modal.production.months}
            </span>
          </ValueCell>
        </div>
      </DataContainer>
    </AnimalInfoContainer>
  );
};

export default AnimalInfoDisplay;
